var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.62 4.41806e-08H1.37882C0.617218 0.000381514 -0.000190691 0.618172 4.41806e-08 1.37997V23.6212C0.000381514 24.3828 0.618172 25.0002 1.37997 25H23.62C24.382 25.0002 24.9998 24.3826 25 23.6206C25 23.6204 25 23.6202 25 23.62V1.37882C24.9996 0.617218 24.3818 -0.000190691 23.62 4.41806e-08Z",
    fill: "#4267B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2607 24.9998V15.3318H20.52L21.0083 11.5476H17.2607V9.13752C17.2607 8.04442 17.5642 7.2996 19.1317 7.2996H21.1182V3.92416C20.7726 3.8782 19.5868 3.77539 18.207 3.77539C15.3261 3.77539 13.3545 5.5332 13.3545 8.76273V11.5476H10.1074V15.3318H13.3545V24.9998H17.2607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnFacebook);
export default __webpack_public_path__ + "static/media/btn-facebook.aa4bb1c5ae5f7406af33a0880b7c651c.svg";
export { ForwardRef as ReactComponent };